

exports.__esModule = true;

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _auth = require('xo-models/src/auth');

var _logger = require('xo-beaver/dist/logger');

require('xo-login-components/src/create-password/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPageCreatePasswordDirective', {
    tag: 'xo-page-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            this.reason = _uiRouter.$stateParams.targetPage;
            this.onContinue = function () {
                return _this.goto('.passwordRecovery');
            };

            this.logout = function () {
                _logger.$logger.info('not_you_logout');
                _this.auth.action('logout').then(function () {
                    _this.goto('checkout.login', {
                        source: 'NOT_YOU'
                    });
                });
            };
        }
    }
});


_squid.$Component;

_uiRouter.$stateParams;

_auth.$AuthModel;

_logger.$logger;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-create-password/directive.js
 ** module id = 449
 ** module chunks = 1
 **/